import { MARK_LINK, render } from "storyblok-rich-text-react-renderer";

import { RichtextStoryblok } from "@/generated/sb/sb-types";
import { StoryblokComponent } from "@frend-digital/storyblok";
import clsx from "clsx";
import Link from "../Link";
import styles from "./index.module.css";

export const RichText = ({
  children,
  className,
  ...rest
}: React.ComponentProps<"div">) => {
  return (
    <div {...rest} className={clsx(styles.richText, className)}>
      {children}
    </div>
  );
};

interface SBRichText {
  blok: RichtextStoryblok | string;
  className?: string;
  preview: boolean;
}

export const RichTextRender = ({
  blok,
  className = "",
  preview,
}: SBRichText) => {
  const content =
    typeof blok === "string" ? (
      <p>{blok}</p>
    ) : (
      render(blok, {
        defaultBlokResolver: (name, props) => (
          <StoryblokComponent
            blok={{ component: name, ...props }}
            preview={preview}
          />
        ),
        markResolvers: {
          [MARK_LINK]: (children, attributes) =>
            attributes.href ? (
              <Link href={attributes.href} target={attributes.target}>
                {children}
              </Link>
            ) : (
              <>{children}</>
            ),
        },
      })
    );

  return <RichText className={className}>{content}</RichText>;
};
